import * as React from "react";
import {Component} from "react";
import {LinearProgress} from "@octopusdeploy/design-system-components";
import repository from "client/repository";
import {InstanceLimitResource} from "~/client/resources/instanceLimitResource";
import externalSystemLinks from "~/externalSystemLinks";
import {RouteComponentProps} from "react-router-dom";
import { Callout } from "@octopusdeploy/design-system-components";
import PaperLayout from "~/components/PaperLayout";
import InternalLink from "~/components/Navigation/InternalLink";

type Props = RouteComponentProps<{ shortId: string }>;

interface State {
    error?: string;
}

class TempBillingRedirectLayout extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    async componentDidMount() {
        const shortId = this.props.match.params.shortId;
        try {
            const instancesByShortId = await repository.HostedInstances.list({
                shortId: shortId, 
                take: 1
            });
            
            const resources = instancesByShortId.Resources;
            
            if (resources && resources.length > 0) {
                const instanceId = resources[0].Id;

                const instanceLimit = await repository.InstanceLimits.getForInstance(instanceId);

                //Automagic external redirects can only happen when we trigger JavaScript, could make a component for this but overkill for a temporary feature https://stackoverflow.com/questions/42914666/react-router-external-link
                window.location.href = externalSystemLinks.billing.subscriptionDetails(instanceLimit);
            } else {
                this.setState({ error: `Could not find instance with given ShortId ${shortId}` });
            }
        } catch (e) {
            this.setState({ error: `Failed to load instance data for ShortId ${shortId}. Please try again.` });
        }
    }
    render() {        
        if (this.state.error) {
            return <PaperLayout>
                <Callout type="warning" title="Warning">
                    <p>{this.state.error}</p>
    
                    <p><InternalLink to={`/instances?skip=0&shortId=${encodeURIComponent(this.props.match.params.shortId)}`}>Search for your instance here</InternalLink></p>
                </Callout>
            </PaperLayout>;
        } 
        
        return <LinearProgress variant="indeterminate" show={true} />; //componentDidMount above will redirect if shortId finds a subscription
    }
}

export default TempBillingRedirectLayout;